import { makeStyles } from '@material-ui/core';
import React from 'react';

const useEstilos = makeStyles(() => ({
	'loader': {
        color: 'rgb(0, 0, 0)',
        fontSize: '10px',
        width: '1.2em',
        height: '1.2em',
        borderRadius: '50%',
        position: 'absolute',
        textIndent: '-9999em',
        animation: 'mulShdSpin 1.3s infinite linear',
        transform: 'translateZ(0) translate(-50%, -50%)',
        margin: '0',
        top: '50%',
        left: '50%',
        msTransform: 'translate(-50%, -50%)',
		maxWidth: '250px',
		maxHeight: '150px'
	}
}));

export const LoadingComponent =  () =>{   
    const classes = useEstilos();
    return <span className={classes.loader}></span> };
